import { createContext, ReactNode, useContext } from "react"

interface DataContextProviderProps {
  children: ReactNode
}

interface DataContext {
  // Empty for now - migration tool doesn't need complex data management
}

const Context = createContext<DataContext | null>(null)

export function DataContext({ children }: DataContextProviderProps) {
  return <Context.Provider value={{}}>{children}</Context.Provider>
}

export const useData = () => {
  const context = useContext(Context)
  if (!context) {
    throw new Error("useDataContext must be used within a DataContextProvider")
  }
  return context
}
